import { FC, ReactNode } from 'react';

import styles from './MapControlsSlots.css';

type MapMapControlsSlotsProps = {
  tags?: ReactNode;
  topControls?: ReactNode;
  rightControls?: ReactNode;
};

export const MapControlsSlots: FC<MapMapControlsSlotsProps> = props => {
  const { tags, topControls, rightControls } = props;

  return (
    <div className={styles['map-controls-container']}>
      <div className={styles['map-controls-wrapper']}>
        {tags && <div className={styles['tags']}>{tags}</div>}
        {topControls && <div className={styles['top-controls']}>{topControls}</div>}
        {rightControls && <div className={styles['right-controls']}>{rightControls}</div>}
      </div>
    </div>
  );
};
